const randomizeList = (items: any[]) => {
  return items.slice().sort(() => {
    return Math.random() - 0.5;
  });
};

export default randomizeList;
